import { Component, ChangeDetectionStrategy, output, input } from '@angular/core';
import { Filter } from '../filter';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-table-column-filter',
  templateUrl: './table-column-filter.component.html',
  styleUrls: ['./table-column-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu],
})
export class TableColumnFilterComponent {
  public readonly identifier = input.required<string>();

  public readonly filters = input<string[]>([]);

  public readonly selected = input<string[]>([]);

  public readonly filter = output<Filter>();

  isSelected(filter: string) {
    return this.selected().indexOf(filter) > -1 ? true : null;
  }

  applyFilter(filter: string) {
    const selected = !this.isSelected(filter);

    if (selected) {
      this.selected().push(filter);
    } else {
      const index = this.selected().indexOf(filter);
      if (index > -1) {
        this.selected().splice(index, 1);
      }
    }

    this.filter.emit(new Filter(this.identifier(), this.selected()));
  }

  stopBubble(e: any) {
    e.stopPropagation();
  }
}
